import { render, staticRenderFns } from "./PriceChangeRequestList.vue?vue&type=template&id=6887bf08&scoped=true&"
import script from "./PriceChangeRequestList.vue?vue&type=script&lang=js&"
export * from "./PriceChangeRequestList.vue?vue&type=script&lang=js&"
import style0 from "./PriceChangeRequestList.vue?vue&type=style&index=0&id=6887bf08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887bf08",
  null
  
)

export default component.exports